import { useEffect, useState } from 'react';

import './VolverArriba.css';

function VolverArriba() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const controlarScroll = () => {
      setVisible(window.scrollY > 500);
    };

    window.addEventListener('scroll', controlarScroll);

    controlarScroll();

    return () => {
      window.removeEventListener(
        'scroll',
        controlarScroll
      );
    };
  }, []);

  const subir = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  };

  return (
    <button
      type="button"
      className={`volver-arriba ${
        visible ? 'volver-arriba-visible' : ''
      }`}
      onClick={subir}
      aria-label="Volver al principio de la página"
      title="Volver arriba"
    >
      <span aria-hidden="true">↑</span>
    </button>
  );
}

export default VolverArriba;